
import { NgModule } from '@angular/core';

import { ViaAccessEditProvider } from './via-access-edit.provider';
import { ViaAccessListProvider } from './via-access-list.provider';

export * from './via-access-edit.provider';
export * from './via-access-list.provider';

export {
  ViaAccessListProvider,
  ViaAccessEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    ViaAccessEditProvider,
    ViaAccessListProvider
  ]
})
export class ViaAccessBackendModule { }
